import type { IServiceGraderPoolProvider } from '@common/interfaces';
import { TableBody } from '@frontend/components/elements/common';
import { NoResult } from '../shared/NoResult';
import { ServiceGraderPoolProviderRow } from './ServiceGraderPoolProviderRow';

export function ServiceGraderPoolProviderListBody(props: IListTableBodyProps) {
    if (props.serviceGraderPoolProviders.length) {
        return (
            <TableBody>
                {props.serviceGraderPoolProviders.map((serviceGraderPoolProvider: IServiceGraderPoolProvider) => (
                    <ServiceGraderPoolProviderRow
                        deleteServiceGraderPoolProvider={props.deleteServiceGraderPoolProvider}
                        editServiceGraderPoolProvider={props.editServiceGraderPoolProvider}
                        key={serviceGraderPoolProvider.serviceProviderId}
                        maxGradingsPerDay={serviceGraderPoolProvider.maxGradingsPerDay}
                        maxGradingsPerMonth={serviceGraderPoolProvider.maxGradingsPerMonth}
                        organization={serviceGraderPoolProvider.serviceProvider.employment.organization}
                        practitioner={serviceGraderPoolProvider.serviceProvider.employment.practitioner}
                        serviceGraderPoolProviderId={serviceGraderPoolProvider.id}
                        serviceProviderId={serviceGraderPoolProvider.serviceProviderId}
                    />
                ))}
            </TableBody>
        );
    } else {
        return (
            <TableBody>
                <NoResult colspan={3} />
            </TableBody>
        );
    }
}

interface IListTableBodyProps {
    deleteServiceGraderPoolProvider: (serviceGraderPoolProviderId: string, serviceProviderId: string) => Promise<void>;
    editServiceGraderPoolProvider: (
        serviceProviderId: string,
        maxGradingsPerDay: number | null,
        maxGradingsPerMonth: number | null
    ) => Promise<void>;
    serviceGraderPoolProviders: IServiceGraderPoolProvider[];
}
